<p-toast></p-toast>
<div class="permissoes-container">
    <div class="permissoes-header">
        <button pButton pRipple type="button" [disabled]="permissoesService.can('direito_grupo_salvar') == false"
            class="flex mb-2" label="Salvar" (click)="save()"></button>
        <p-dropdown [filter]="true" class="p-fluid mb-2" placeholder="Selecione o grupo" (onChange)="changeGrupo()"
            [options]="grupoList" [(ngModel)]="selectedGrupo" optionLabel="nome"></p-dropdown>
    </div>
    <div class="permissoes-table-wrapper" #tableWrapper>
        <p-treeTable *ngIf="selectedGrupo != null" [value]="dataSource" [columns]="cols" selectionMode="checkbox"
            [(selection)]="selectedDireitos" [scrollable]="true" [scrollHeight]="scrollHeight">
    <ng-template pTemplate="caption">
        <div class="flex">
            <p-treeTableHeaderCheckbox></p-treeTableHeaderCheckbox>
            <span class="ml-2">Selecionar todos</span>
        </div>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
        <tr>
            <th *ngFor="let col of columns">
                {{col.header}}
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
        <tr>
            <td *ngFor="let col of columns; let i = index">
                <p-treeTableToggler [rowNode]="rowNode" *ngIf="i == 0"></p-treeTableToggler>
                <p-treeTableCheckbox [value]="rowNode" *ngIf="i == 0"></p-treeTableCheckbox>
                {{rowData[col.field]}}
            </td>
        </tr>
    </ng-template>
        </p-treeTable>
    </div>
</div>
